import { TableColumn } from '../types/table-column.type';

/**
 * Returns the columns by pin.
 */
export function columnsByPin(cols: Array<TableColumn>): { left: Array<TableColumn>; center: Array<TableColumn>; right: Array<TableColumn> } {
  const ret: { left: Array<TableColumn>; center: Array<TableColumn>; right: Array<TableColumn> } = {
    left: [],
    center: [],
    right: []
  };

  if (cols) {
    for (const col of cols) {
      if (col.frozenLeft) {
        ret.left.push(col);
      } else if (col.frozenRight) {
        ret.right.push(col);
      } else {
        ret.center.push(col);
      }
    }
  }

  return ret;
}

/**
 * Returns the widths of all group sets of a column
 */
export function columnGroupWidths(groups: { left: Array<TableColumn>; center: Array<TableColumn>; right: Array<TableColumn> }, all: Array<TableColumn>): { left: number; center: number; right: number; total: number } {
  return {
    left: columnTotalWidth(groups.left),
    center: columnTotalWidth(groups.center),
    right: columnTotalWidth(groups.right),
    total: Math.floor(columnTotalWidth(all))
  };
}

/**
 * Calculates the total width of all columns and their groups
 */
export function columnTotalWidth(columns: Array<TableColumn>, prop?: string): number {
  let totalWidth = 0;

  if (columns) {
    for (const c of columns) {
      const has = prop && (c as Record<string, unknown>)[prop];
      const width = has ? (c as Record<string, unknown>)[prop] as number : c.width;
      totalWidth = totalWidth + parseFloat(String(width));
    }
  }

  return totalWidth;
}

/**
 * Calculates the total width of all columns and their groups
 */
export function columnsTotalWidth(columns: Array<TableColumn>, prop?: string): number {
  let totalWidth = 0;

  for (const column of columns) {
    const has = prop && (column as Record<string, unknown>)[prop];
    totalWidth = totalWidth + (has ? (column as Record<string, unknown>)[prop] as number : column.width);
  }

  return totalWidth;
}

export function columnsByPinArr(val: Array<TableColumn>): Array<{ type: string; columns: Array<TableColumn> }> {
  const colsByPinArr = [];
  const colsByPin = columnsByPin(val);

  colsByPinArr.push({ type: 'left', columns: colsByPin['left'] });
  colsByPinArr.push({ type: 'center', columns: colsByPin['center'] });
  colsByPinArr.push({ type: 'right', columns: colsByPin['right'] });

  return colsByPinArr;
}
